/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import Provider from "./Provider";
import { SidebarGlobal } from "./_SidebarGlobal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import MessageDialog from "./MessageDialog";
import L from "./Lang";
import AppActions from "./AppActions";
import Card from "./Card";
import FormInput from "./FormInput";
import React from "react";

class ProviderView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                roles: [],
                accounts: []
            },
            saving: false
        };
        if (this.props.params.id) {
            this.state.loading = true;
        }
        this.submitRef = React.createRef();
    }

    async componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => this.submitRef.current?.click()}>
            <FontAwesomeIcon icon={fa.faSave} /> <L>Save</L>
        </button></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = () => {
        if (this.props.params.id) {
            qreq.get('/api/provider/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.setState({ item: j.item });
                    this.loadAccounts(j.item);
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    loadAccounts = async (_item) => {
        const item = { ..._item };
        await this.fillListAsync('/api/account/list', 'accounts');
        item._accounts = [];
        item.accounts.forEach(i => item._accounts.push(i.id));
        this.setState({
            item: item
        });
    }

    updateAccounts = (_item) => {
        const item = { ..._item };
        item.accounts = [];
        item._accounts.forEach(i => item.accounts.push({ id: i }));
        this.setState({
            item: item
        });
    }

    submit = (e) => {
        e?.preventDefault();

        this.setState({ item: this.state.item, saving: true });

        qreq.post('/api/provider/save', { ...this.state.item }, (j) => {
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    change = () => {
        setTimeout(() => {
            this.forceUpdate();
        }, 100);
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Edit Provider</L></h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Edit Provider</L></h1>
                <Breadcrumb path={[['Providers', '/provider/list'], ['Edit']]} />
                <AppActions>
                    <button ref={this.submitRef} type="submit" className="btn btn-success btn-lg"><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button>
                </AppActions>
                <Provider item={this.state.item} edit />
                {this.state.accounts ? <Card title="Accounts">
                    <FormInput model={this.state.item} name="accounts" label="Select accounts this provider belongs in" type="multiselect" options={this.state.accounts} useObjectValue onChange={this.change} />
                </Card> : <LoadingAlert />}
                {this.state.saving && <MessageDialog title="Saving" message="Processing..." />}
            </form>
        </div>;
    }
}

export default withParams(ProviderView);